/**
 * This file was copied from dashboard into clowncar as part of a cleanup effort
 */
import AppConstants from 'constants/AppConstants';

export function setOpenModal(): BaseTockAction {
  return {
    type: AppConstants.KEYBOARD_SHORTCUTS_OPEN_MODAL,
  };
}

export function setCloseModal(): BaseTockAction {
  return {
    type: AppConstants.KEYBOARD_SHORTCUTS_CLOSE_MODAL,
  };
}
